// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal--turbo .Polaris-Modal-Dialog__Modal {
    width: 788px;
    border-radius: 12px;
}

.modal-boost-turbo {
    position: relative;
    width: 788px;
    height: 340px;
    overflow: hidden;
}

.modal-boost-turbo map {
    position: absolute;
    top: 0;
    left: 0;
}

.modal-boost-turbo img {
    max-height: 100%;
    max-width: 100%;
}

.modal-boost-turbo .closeBtn {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 999;
}

.modal-boost-turbo .btn-blind {
    width: 257px;
    height: 41px;
    position: absolute;
    cursor: pointer;
    bottom: 62px;
    left: 45px;
}

.modal-boost-turbo .closeBtn:hover .Polaris-Icon__Svg {
    fill: white;
}


.modal-boost-turbo .closeBtn .Polaris-Icon__Svg {
    fill: white;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Dialog__Modal {
    width: 850px;
    max-width: 850px !important;
    border-radius: 8px;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Header {
    border: 0;
}

.custom-modal.custom-modal--turbo-how-to-claim .Polaris-Modal-Header {
    border: 1px solid var(--p-divider);
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer {
    justify-content: flex-end;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer .Polaris-ButtonGroup__Item {
    margin-left: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".custom-modal--turbo .Polaris-Modal-Dialog__Modal {\n    width: 788px;\n    border-radius: 12px;\n}\n\n.modal-boost-turbo {\n    position: relative;\n    width: 788px;\n    height: 340px;\n    overflow: hidden;\n}\n\n.modal-boost-turbo map {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.modal-boost-turbo img {\n    max-height: 100%;\n    max-width: 100%;\n}\n\n.modal-boost-turbo .closeBtn {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    z-index: 999;\n}\n\n.modal-boost-turbo .btn-blind {\n    width: 257px;\n    height: 41px;\n    position: absolute;\n    cursor: pointer;\n    bottom: 62px;\n    left: 45px;\n}\n\n.modal-boost-turbo .closeBtn:hover .Polaris-Icon__Svg {\n    fill: white;\n}\n\n\n.modal-boost-turbo .closeBtn .Polaris-Icon__Svg {\n    fill: white;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Dialog__Modal {\n    width: 850px;\n    max-width: 850px !important;\n    border-radius: 8px;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Header {\n    border: 0;\n}\n\n.custom-modal.custom-modal--turbo-how-to-claim .Polaris-Modal-Header {\n    border: 1px solid var(--p-divider);\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer {\n    justify-content: flex-end;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer .Polaris-ButtonGroup__Item {\n    margin-left: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
